// Test Cloudinary configuration for browser environment
import { testCloudinaryConnection as testConnection } from './firebase/cloudinary';

// Test function
export const testCloudinaryConnection = async () => {
  try {
    console.log('Testing Cloudinary connection...');
    
    // Test basic configuration
    console.log('Cloud Name: dz9qguszu');
    console.log('Upload Preset: centron_aerospace_products');
    
    // Test connection using the cloudinary module
    const result = await testConnection();
    
    return result;
  } catch (error) {
    console.error('Cloudinary connection failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default testCloudinaryConnection; 